import * as React from "react";
import { SearchCtx } from "../context/SearchContext";

const useSearchContext = () => React.useContext(SearchCtx);

export default useSearchContext;
